import { getGraphQLClient } from 'utilities/graphql';

import GetUserChecklist from './GetUserChecklist.gql';

export const getMostCompleteNamePossible = user => {
  if (!user) {
    return 'User';
  }

  if (user.first_name) {
    if (user.last_name) {
      return user.first_name + ' ' + user.last_name;
    }

    return user.first_name;
  }

  return user.email;
};

export const getUserChecklist = () => {
  const gqlClient = getGraphQLClient();

  return gqlClient.query({ query: GetUserChecklist });
};
